/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type { Container } from '@modules/cloud-api/v1/types'
import type { AsyncRequestState } from '@modules/ui-types'
import type { WithRouterProps } from '@modules/routing/withRouter'
import withRouter from '@modules/routing/withRouter'

import { getContainer } from '@/reducers/containerSets'
import { fetchContainerRequest } from '@/reducers/asyncRequests/registry'

import { fetchContainer } from '../../actions/containerSets'

import ContainerOverview from './Container'

type StateProps = {
  regionId: string
  containerSetId: string
  containerId: string
  container: Container | null
  fetchContainerRequest: AsyncRequestState
}

type DispatchProps = {
  fetchContainer: () => void
}

type ConsumerProps = WithRouterProps<{
  regionId: string
  containerSetId: string
  containerId: string
}>

const mapStateToProps = (
  state,
  {
    router: {
      params: { regionId, containerSetId, containerId },
    },
  }: ConsumerProps,
): StateProps => ({
  regionId,
  containerSetId,
  containerId,
  container: getContainer(state, regionId, containerSetId, containerId),
  fetchContainerRequest: fetchContainerRequest(state, regionId, containerSetId, containerId),
})

const mapDispatchToProps = (
  dispatch,
  {
    router: {
      params: { regionId, containerSetId, containerId },
    },
  }: ConsumerProps,
): DispatchProps => ({
  fetchContainer: () => dispatch(fetchContainer({ regionId, containerSetId, containerId })),
})

export default withRouter(
  connect<StateProps, DispatchProps, ConsumerProps>(
    mapStateToProps,
    mapDispatchToProps,
  )(ContainerOverview),
)
